import styled from 'styled-components';

export const FlexLayout = styled.div`
  display: flex;
  flex-direction: ${({ direction = 'column' }) => direction};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  justify-content: ${({ justifyContent = 'center' }) => justifyContent};
  background-color: ${({ bg, theme }) => bg || theme.colors.white};
  position: relative;
  width: ${({ width = '100%' }) => width};
  height: ${({ height = '100%' }) => height};
`;
